import { render } from "./HoundSelectOption.vue?vue&type=template&id=8493e0c4&scoped=true&ts=true"
import script from "./HoundSelectOption.vue?vue&type=script&lang=ts"
export * from "./HoundSelectOption.vue?vue&type=script&lang=ts"

import "./HoundSelectOption.vue?vue&type=style&index=0&id=8493e0c4&lang=scss&scoped=true"

import exportComponent from "/workspace/hound-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8493e0c4"]])

export default __exports__